import { render, staticRenderFns } from "./AccountsAdd.vue?vue&type=template&id=6b61d2aa&scoped=true&"
import script from "./AccountsAdd.vue?vue&type=script&lang=js&"
export * from "./AccountsAdd.vue?vue&type=script&lang=js&"
import style0 from "./AccountsAdd.vue?vue&type=style&index=0&id=6b61d2aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b61d2aa",
  null
  
)

export default component.exports